import { useState, useEffect } from "react";

import { api } from "../../utlis/user/api.utlis";
import ApiService from "../../core/services/ApiService";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalFooter } from "react-bootstrap";
import CareBusiness from "../../assets/user/images/carebusiness.svg";
import CareIndividual from "../../assets/user/images/careIndividual.svg";
import CareUsers from "../../assets/user/images/careuser.svg";
import toast from "react-hot-toast";

import { routes as userRoutes } from "../../utlis/user/routes.utlis";
import { routes as providerRoutes } from "../../utlis/provider/routes.utlis";
import { routes as staffRoutes } from "../../utlis/staff/routes.utlis";
import Loader from "../../layouts/loader/Loader";

const SwitchProfile = () => {
    const navigate = useNavigate();
    const [tab, setTab] = useState();
    const [switchModal, setSwitchModal] = useState(false);
    const [currentRole, setCurrentRole] = useState();
    const [userEmail, setUserEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const switchRole = async () => {
        if (tab === undefined) {
            toast.error("Please select profile to switch");
            return false;
        }
        setLoading(true);
        let redirectRoute = '';
        const response = await ApiService.postAPIWithAccessToken(
            api.switchProfile, { email: userEmail, user_type: tab }
        );
        if (response.data.status && response.data.statusCode === 200) {
            const body = response.data;
            const userData = body.data.user;
            toast.success(response.data.message);
            setSwitchModal(false);
            if (tab === 2) {
                redirectRoute =
                    userData &&
                        (userData.provider_profile_completed === 0 ||
                            userData.provider_profile_completed === null)
                        ? providerRoutes.profile
                        : providerRoutes.dashboard;
            } else if (tab === 3) {
                redirectRoute =
                    userData &&
                        (userData.staff_profile_completed === 0 ||
                            userData.staff_profile_completed === null)
                        ? staffRoutes.profile
                        : staffRoutes.dashboard;
            } else {
                redirectRoute = userRoutes.dashboard;
            }

            const localData = {
                token: body.data.token,
                userId:
                    userData.user_type === 2 || userData.user_type === 3
                        ? userData.provider_id
                        : userData.userid,
                email: userData.email,
                fullname: userData.fullname,
                mobile: userData.mobile,
                role_id: userData.user_type,
                provider_profile_completed: userData.provider_profile_completed,
                staff_profile_completed: userData.staff_profile_completed,
            };

            localStorage.setItem("careexchange", JSON.stringify(localData));

            navigate(redirectRoute);
            window.location.reload();
        } else {
            toast.error(response.data.message);
        }
        setLoading(false);
    }

    useEffect(() => {
        const careexchange = JSON.parse(localStorage.getItem("careexchange"));
        const role_id = careexchange?.role_id;
        if (role_id !== 0 || role_id !== null) {
            setCurrentRole(role_id);
            setUserEmail(careexchange?.email);
        }
    }, []);

    return (
        <>
            {loading ? <div style={ {position: 'fixed', inset: 0, zIndex: 9} }><Loader /></div> : null}
            <button
                className="btn btn-gr"
                onClick={() => setSwitchModal(true)} >
                Switch Profile
                <i className="mdi mdi-account-switch-outline ps-3"></i>
            </button>

            <Modal
                show={switchModal}
                onHide={() => setSwitchModal(false)} >
                <ModalBody className="p-4 text-center">
                    <h4 className="mb-4">Choose Profile to Switch</h4>
                    <div className="row g-2">
                        <div className="col-md-4">
                            <div className={`PBCheckbox ${currentRole === 1 ? 'disabled' : ''}`}>
                                <input
                                    type="radio"
                                    name="user_type"
                                    id="Users"
                                    value="1"
                                    disabled={currentRole === 1 ? true : false}
                                    checked={tab === 1}
                                    onChange={() => {
                                        setTab(1);
                                    }}
                                />
                                <label htmlFor="Users">
                                    <span className="checkbox-circle-mark"></span>
                                    <div className="account-option-media">
                                        <img src={CareUsers} alt="Care Users" />
                                    </div>
                                    <div className="account-option-text">
                                        <h4>Care</h4>
                                        <h3>Users</h3>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className={`PBCheckbox ${currentRole === 3 ? 'disabled' : ''}`}>
                                <input
                                    type="radio"
                                    name="user_type"
                                    id="Individual"
                                    disabled={currentRole === 3 ? true : false}
                                    checked={tab === 3}
                                    onChange={() => {
                                        setTab(3);
                                    }}
                                />
                                <label htmlFor="Individual">
                                    <span className="checkbox-circle-mark"></span>
                                    <div className="account-option-media">
                                        <img src={CareIndividual} alt="Care Individual" />
                                    </div>
                                    <div className="account-option-text">
                                        <h4>Care-Staff</h4>
                                        <h3>Individual</h3>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className={`PBCheckbox ${currentRole === 2 ? 'disabled' : ''}`}>
                                <input
                                    type="radio"
                                    name="user_type"
                                    id="Business"
                                    value="2"
                                    disabled={currentRole === 2 ? true : false}
                                    checked={tab === 2}
                                    onChange={() => {
                                        setTab(2);
                                    }}
                                />
                                <label htmlFor="Business">
                                    <span className="checkbox-circle-mark"></span>
                                    <div className="account-option-media">
                                        <img src={CareBusiness} alt="Care Business" />
                                    </div>
                                    <div className="account-option-text">
                                        <h4>Care Provider</h4>
                                        <h3>Business</h3>
                                    </div>
                                </label>
                            </div>
                        </div>


                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        className="btn btn-re"
                        onClick={() => setSwitchModal(false)} >
                        Cancel
                    </button>
                    <button className="btn btn-gr" onClick={() => switchRole()} >
                        Yes, Switch
                    </button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default SwitchProfile;